import { SyntheticEvent, useState } from 'react';
import { Box, Grid } from '@mui/material';
import { RadioGroupField } from '@components/radioButton';
import { SearchField } from '@components/search/SearchField';
import { Button } from '@components/button';
import { ModifyAttributeModal } from '@components/modals/ModifyAttributeModal';
import { shallow } from 'zustand/shallow';
import { useStore } from '@store/GlobalStore';

interface AttributesTabFooterProps {
  isDialogMode?: boolean;
  onAttributeTypeChange: (type: 'all' | 'active') => void;
  onSearchChange: (value: string) => void;
  initialAttributeType?: 'all' | 'active';
  onClose?: () => void;
  quoteId?: string;
}

export const AttributesTabFooter = ({
  isDialogMode = false,
  onAttributeTypeChange,
  onSearchChange,
  initialAttributeType = 'all',
  onClose,
  quoteId,
}: AttributesTabFooterProps) => {
  const [attributeType, setAttributeType] = useState<'all' | 'active'>(initialAttributeType);
  const [isModifyModalOpen, setIsModifyModalOpen] = useState(false);
  const { isAdmin, isPortalAdmin } = useStore((state) => state.userAuth, shallow);

  const handleAttributeTypeChange = (_e: SyntheticEvent, value: string) => {
    const newType = value as 'all' | 'active';
    setAttributeType(newType);
    onAttributeTypeChange(newType);
  };

  const handleSearchChange = (value: string) => {
    onSearchChange(value);
  };

  return (
    <Box
      sx={{
        flexShrink: 0,
        padding: { xs: 1, md: 0 },
        backgroundColor: 'background.paper',
        borderTop: '1px solid',
        borderColor: 'divider',
      }}
    >
      <Grid
        container
        sx={{
          gap: 2,
          alignItems: 'center',
          justifyContent: 'space-between',
          p: '15px',
        }}
      >
        <Grid>
          <RadioGroupField
            onChange={handleAttributeTypeChange}
            defaultValue={attributeType}
            options={[
              { value: 'all', label: 'All' },
              { value: 'active', label: 'Active only' },
            ]}
            sxProps={{
              label: {
                color: 'font.main',
                fontSize: '14px',
              },
            }}
          />
        </Grid>
        <Grid sx={{ display: 'flex', justifyContent: 'flex-end', gap: 2 }}>
          <Grid>
            <SearchField onChange={handleSearchChange} />
          </Grid>
          {(isAdmin || isPortalAdmin) && quoteId && (
            <Grid>
              <Button variant='outlined' onClick={() => setIsModifyModalOpen(true)} size='small'>
                Modify Attributes
              </Button>
            </Grid>
          )}
          {isDialogMode && (
            <Grid>
              <Button variant='contained' onClick={onClose}>
                Close
              </Button>
            </Grid>
          )}
        </Grid>
      </Grid>

      {quoteId && (
        <ModifyAttributeModal
          isOpen={isModifyModalOpen}
          onClose={() => setIsModifyModalOpen(false)}
          quoteId={quoteId}
        />
      )}
    </Box>
  );
};
